export const isInvoiceOnly = (contractBalance?: number | null): boolean =>
  typeof contractBalance === 'number';
